import { Heading } from '@//components/Heading';

interface SectionHeadingProps {
  children: React.ReactNode;
  id?: string;
  headingLevel?: 2 | 3 | 4;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({
  id,
  children,
  headingLevel = 2,
}) => (
  <Heading level={headingLevel} size="xl" id={id}>
    {children}
  </Heading>
);
